module.exports = __webpack_public_path__ + "static/media/logo-lauro-asesores-02-1030x226.3eecb851.png";